import React from 'react';
import { useDispatch } from 'react-redux';
import { clearSession } from '../../utils/initiate';

const Warning = ({history}) => {

    const dispatch = useDispatch();

    return(
        <div style={{width : '100%'}}>
            <div className="d-flex flex-column align-items-center justify-content-center" style={{width: 'auto', height: '85vh'}}>
                <img src={'/Assets/warning.svg'} alt="Warning" style={{width: '35%', height: 'auto'}} />
                <p className="mt-4">Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a meaningful content.</p>
                <button className="btn btn-primary my-4" onClick={() => clearSession(dispatch, history)}>Logout</button>
            </div>
        </div>
    );
};

export default Warning;